import React, {useEffect} from "react";
import type Product from "../models/Product";
import {Swiper} from "swiper/react";
import "./ProductListPage.scss";
import type {translate} from "../i18n/i18n";
import {withTranslation} from "react-i18next";
import type Category from "../models/Category";
import ProductDoubleSwiperSlider from "./ProductDoubleSwiperSlider";
import {useParams} from "react-router";
import Pagination from "./Pagination";
import {getBtnTextColor} from "../helper/setTextColor";
import {SPECIAL_CATEGORY} from "../actions/filter";
import {Navigation} from "swiper/modules";

export type ProductListPageProps = {
    products: Product[],
    goHome: () => void,
    t: translate,
    category: Category,
    resetCategory: () => void,
    setCategoryByKey: string => void,
    setPage: number => void,
    currentPageIndex: number,
    totalItems: number,
    totalPages: number,
    itemsPerPage: number,
    loadingNextPage: boolean,
};

const ProductListPage = (props: ProductListPageProps) => {
    const {
        products,
        category,
        setCategoryByKey
    } = props;
    const {categoryKey} = useParams();

    const nextSwiperRef = React.useRef(null);
    const prevSwiperRef = React.useRef(null);

    const isTouchDevice = () => {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    };


    useEffect(() => {
        if (category.key !== categoryKey) {
            setCategoryByKey(categoryKey);
        }
    }, [categoryKey, category, setCategoryByKey]);

    const handleHistoryBack = e => {
        e.preventDefault();
        props.goHome();
        props.resetCategory();
    };

    return <div className="main">
	<div className="control">
		<span><button className="toggle-detail" data-testid={"backButton"}
                      style={{color: getBtnTextColor()}} onClick={e => handleHistoryBack(e)}>
			{props.t("navigation.back")}
		</button></span>
		<span></span>
	</div>
	<div className="head" data-testid={"categoryTitle"}>
		<span>
			{(category.title === SPECIAL_CATEGORY.TOP)
                ? props.t("main.topOffers")
                : (category.title === SPECIAL_CATEGORY.ALL ? props.t("main.topOffers") : category.title)
            }
		</span>
		<Pagination
                loadingNextPage={props.loadingNextPage}
                currentPageIndex={props.currentPageIndex}
                totalPages={props.totalPages}
                totalItems={props.totalItems}
                itemsPerPage={props.itemsPerPage}
                setPage={props.setPage}
                t={props.t}
            />
	</div>
	<div id={"category"} className={"swiper"} data-testid="categoryPage">
		<Swiper
                observer={true}
                observeParents={true}
                parallax={true}
                modules={[Navigation]}
                className={"swiper-container swiper-list"}
                slidesPerView={1}
                spaceBetween={5}
                autoHeight={true}
                grabCursor={false}
                allowTouchMove={isTouchDevice()}
                noSwiping={true}
                navigation={{
                    nextEl: nextSwiperRef.current,
                    prevEl: prevSwiperRef.current,
                }}
                onInit={swiper => {
                    swiper.params.navigation.nextEl = nextSwiperRef.current;
                    swiper.params.navigation.prevEl = prevSwiperRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                }}
                onResize={swiper => {
                    document.querySelectorAll(".swiper-list > .swiper-wrapper").forEach(it => {
                        it.style.height = "auto";
                    });
                    swiper.updateAutoHeight();
                }}
            >
			<ProductDoubleSwiperSlider products={products}/>
		</Swiper>
		<button
                ref={nextSwiperRef}
                className="swiper-button-next swiper-button-next-tip slider-button-next-1" tabIndex={"0"}
                aria-label={props.t("main.nextSlide")}/>
		<button
                ref={prevSwiperRef}
                className="swiper-button-prev swiper-button-prev-tip slider-button-prev-1" tabIndex={"0"}
                aria-label={props.t("main.prevSlide")}/>
	</div>
    </div>;
};
export default withTranslation()(ProductListPage);
